import { BUITheme } from "@blofin/blofin-ui";
import { cva } from "class-variance-authority";
import { FC } from "react";

const styles = cva(
  "h-[18px] flex items-center justify-center rounded-tl-[4px] rounded-br-[4px] ml-[4px]",
  {
    variants: {
      theme: {
        light: "bg-light-primary",
        dark: "bg-dark-primary"
      }
    }
  }
);

const Hot: FC<{
  theme: BUITheme;
  text?: string;
  className?: string;
  fontSize?: string;
  fontStyle?: string;
  fontClassName?: string;
}> = ({
  theme,
  text = "Hot",
  className = "w-[32px]",
  fontSize = "text-[20px] scale-50",
  fontStyle = "italic",
  fontClassName = "font-bold"
}) => {
  return (
    <span className={`${styles({ theme })} ${className}`}>
      <span className={`${fontSize} font-bold text-light-label`}>
        <i style={{ fontStyle: fontStyle }} className={fontClassName}>
          {text}
        </i>
      </span>
    </span>
  );
};

export default Hot;
